/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('ProjectDetailNewsletterController', ProjectDetailNewsletterController);

    ProjectDetailNewsletterController.$inject = ['entity', '$http', 'Principal'];

    function ProjectDetailNewsletterController(entity, $http, Principal) {
        var vm = this;
        vm.project = entity;
        vm.contactMail = vm.project.contactMail !== null ? vm.project.contactMail : vm.project.profile.user.email;
        vm.action = action;
        vm.sendMail = {startId: 0, projectID: entity.id};
        vm.projectType = entity.type;

        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });

        vm.options = {
            toolbar: [
                ['style', ['bold', 'italic', 'underline', 'clear']],
                ['textsize', ['fontsize']],
                ['fontclr', ['color']],
                ['alignment', ['ul', 'ol']],
                ['view', ['codeview']]
            ]
        };

        function action(action) {
            vm.sendMail.action = action;
            vm.isSaving = true;
            $http.post('api/board/projects/mail/', vm.sendMail).then(function(response) {
                vm.isSaving = false;
            });
        }
    }
})();
